/** @module csi/heading/StringTypeNotSortable */
define([
	"dojo/_base/declare",
	"./StringType"
], function(declare,StringType) {

	return declare(StringType, {
		/**
		 * Amend query spec from base class to not sort since server does not know localized strings
		 * @param {Context} ctx
		 * @param {Heading} h
		 * @param {Spec} spec
		 * @return {Object}
		 */
		getQuerySpec: function(ctx, h, spec) {
			var	qs = this.inherited(arguments);
			qs.notSortable = true;
			return qs;
		}
	});
});